function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M352 128.4L319.7 96 160 256l159.7 160 32.3-32.4L224.7 256z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _ref);

export default __webpack_public_path__ + "static/media/ios-arrow-back.9598a23b.svg";
export { SvgComponent as ReactComponent };